(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/constants/assets/javascripts/settle-requests-serially.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/constants/assets/javascripts/settle-requests-serially.js');
"use strict";


let PromiseStatus;
if (svs.isServer) {
  PromiseStatus = require('./promise-status.es6').PromiseStatus;
} else {
  PromiseStatus = svs.components.marketplaceCompetition.constants.promiseStatus.PromiseStatus;
}

const settleRequestsSerially = async tasks => {
  const responses = [];
  for (const task of tasks) {
    try {
      const value = await task();
      responses.push({
        status: PromiseStatus.Fulfilled,
        value
      });
    } catch (reason) {
      responses.push({
        status: PromiseStatus.Rejected,
        reason
      });
    }
  }
  return responses;
};
const toExport = {
  settleRequestsSerially
};
if (svs.isServer) {
  module.exports = toExport;
} else {
  setGlobal('svs.components.marketplaceCompetition.constants.settleRequestsSerially', toExport);
}

 })(window);